<template>
  <!-- 支付下拉框 -->
  <div class="pay" v-if="ispay" :class="{ pay_active: ispay }">
    <div class="pay_bg" @click="payhike"></div>
    <div class="pay_box">
      <div class="pay_close" @click="payhike">
        <img
          class="pay_close_img"
          :src="require('@/img/' + getTheme + '-close.png')"
          alt=""
        />
        <!-- <img
          class="pay_close_img"
          v-if="getTheme == 1"
          src="@/img/kpclose.png"
          alt
        />
        <img class="pay_close_img" v-else src="@/img/colse.png" alt /> -->
      </div>
      <div class="pay_title">{{ $t("Pay.Confirm") }}</div>
      <!-- 这个是付款的金额  从父元素传下来-->
      <slot></slot>
      <!--  -->
      <div class="pay_card_box">
        <div
          class="pay_card"
          v-for="(item, index) in radios"
          :key="item.id"
          @click="check(index)"
        >
          <div class="pay_card_left">
            <div class="pay_card_left_url">
              <img class="pay_card_left_img" :src="item.icon" alt />
            </div>
            <div class="pay_card_left_text">{{ item.typeName }}</div>
          </div>
          <div class="pay_card_right">
            <!--  -->
            <img
              class="pay_card_right_img"
              src="@/img/select.png"
              v-if="item.isChecked"
              alt
            />
            <img
              class="pay_card_right_img"
              src="@/img/select2.png"
              v-if="!item.isChecked"
              alt
            />
            <input class="pay_card_right_input" type="radio" name="ra" />
          </div>
          <!-- :value="item.value" -->
        </div>
      </div>
      <!--付款  -->
      <div
        class="pay_button"
        :class="bgstate ? 'pay_button_active' : ''"
        v-if="!payBtn"
        @click="goPayment"
        @touchstart="Playtouchstart($event, index)"
        @touchend="Playtouchend($event, index)"
      >
        {{ $t("Pay.Pay") }}
      </div>

      <div class="pay_button2" v-else>{{ $t("Pay.payment") }}</div>
    </div>
    <!-- 加载中提示框 -->
    <div class="tooltip" v-if="isLoading">
      <div class="tooltip_bg"></div>
      <div class="tooltip_box">
        <div class="tooltip_url">
          <img class="tooltip_img" src="@/img/loading.gif" alt />
        </div>
        <div class="tooltip_text">{{ $t("Pay.Loading") }}...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
export default {
  props: {
    ispay: Boolean,
    rechargeItemId: String,
    payBtn: Boolean,
    commodityId: String,
    name: String,
    price: Object,
  },
  data() {
    return {
      bgstate: false,
      isLoading: false,
      payType: "Googlepay",
      radios: [
        {
          label: "Google pay",
          value: "Google pay",
          isChecked: true,
        },
        //  {
        //    label: 'Credit card',
        //    value:'Credit card',
        //    isChecked: false,
        //  },
      ],
      getTheme: "",
    };
  },
  created() {
    window.paySDK && window.paySDK.init();
    console.log("window.paySDK", window.paySDK);
    this.getTheme = configs.getTheme();
  },
  mounted() {
    this.getPayType();
  },
  methods: {
    // ...mapActions("user", ["paymentPay"]),
    ...mapActions("pay", ["PayCreate", "PayType"]),
    Playtouchstart(e, index) {
      this.bgstate = true;
      // this.bg_scrollTop = document.querySelector('.diamond').scrollTop;
    },
    Playtouchend(e, index) {
      this.bgstate = false;
    },

    // 获取支付类型
    async getPayType() {
      const res = await this.PayType({
        $axios: this.$axios,
        appId: configs.bipAppId(),
      });
      if (res.stateCode == 1) {
        console.log("res------", res);
        var data = res.resultInfo.data;
        if (data) {
          for (var i = 0; i < data.length; i++) {
            if (i == 0) {
              data[i].isChecked = true;
              this.payType = data[i].urlType;
            } else {
              data[i].isChecked = false;
            }
          }
        }

        this.radios = data;
      }
    },

    check(index) {
      console.log("index", index);
      this.radios.forEach((item) => {
        item.isChecked = false;
      });
      //再设置当前点击项选中
      this.payType = this.radios[index].urlType;
      // 设置值，以供传递
      this.radios[index].isChecked = true;
      console.log(this.payType);
    },

    // 关闭订单
    payhike(e) {
      var self = this;
      //console.log(self.ispay);
      self.$emit("payBtns", false);
      // self.Share = !self.Share
      self.$emit("payhike", !self.ispay);
    },
    async goPayment() {
      var self = this;
      if (!self.rechargeItemId) {
        return;
      }
      self.$emit("payBtns", true);
      const res = await this.PayCreate({
        $axios: self.$axios,
        appId: configs.bipAppId(),
        orderId: self.rechargeItemId,
        thirdPayType: self.payType,
        payType: 2,
      });
      if (res.stateCode == 1) {
        var Create = res.resultInfo.data;
        var id = self.commodityId;
        var payType = self.payType;
        if (payType == "khalasPay") {
          var navigationbar =
            configs.GetQueryString("navigationbar") ||
            this.$route.query.navigationbar;

          const callbackUrl =
            window.location.origin +
            window.location.pathname +
            "#/diamond?txnId=" +
            localStorage.getItem("txn_id") +
            "&appId=" +
            localStorage.getItem("appId") +
            "&msisdn=" +
            localStorage.getItem("msisdn") +
            "&navigationbar=" +
            navigationbar +
            "&theme=" +
            localStorage.getItem("biptheme");
          const satrtData = res.resultInfo.sdkParams.startData;
          console.log("satrtData", satrtData);
          const obj = {
            source: "webview",
            paymentAppId: satrtData.paymentAppId,
            outTradeCode: satrtData.outTradeCode,
            amount: self.price.cnt,
            currencyCode: "USD",
            secret: satrtData.secret,
            callbackUrl: callbackUrl,
            products: [
              {
                productName: self.name,
                productCount: 1,
                productPrice: self.price.cnt / self.price.ratio,
              },
            ],
          };
          window.paySDK && window.paySDK.payOrder(obj);
        } else {
          if (window.TgaBridge) {
            TgaBridge.sdkPay(
              JSON.stringify({ id: id, order: Create, payType: payType })
            ).then((res) => {
              self.$emit("paystatus", res.change);
            });
          } else if (window.Bridge) {
            window.Bridge.wallet
              .pay(JSON.stringify({ id: id, order: Create, payType: 1 }))
              .then((res) => {
                self.$emit("paystatus", res.change);
              });
          }
        }
      }
      /**
       * 之前的
       * */
      //       this.isLoading = true;
      //    var callbackUrl =   location.origin + "/h5tga/index.html#?url="+  this.$route.path
      //
      // 	  // var callbackUrl =location.origin + "/h5tga/index.html#" + this.$route.path;
      // 	  // var callbackUrl = location.origin + "/h5tga/index.html?url=" +  this.$route.path
      //       // console.log(callbackUrl)
      //       const url = await this.paymentPay({
      //         $axios: this.$axios,
      //         rechargeitemid: this.rechargeItemId,
      //         quantity: 1,
      //         callbackurl: callbackUrl
      //       });
      //         // window.open(url)
      //         // window.location.replace(url)
      //       url && (window.location = url);
    },
  },
};
</script>

<style scoped="scoped">
.pay {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
.pay_bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000000;
  opacity: 0.5;
  width: 100%;
  height: 100%;
}
.pay_box {
  width: 100%;
  /* height: 8.68rem; */
  position: absolute;
  bottom: -8.68rem;
  left: 0;
  background-color: var(--payBg);
  border-radius: 0.48rem 0.48rem 0 0;
  padding: 0.75rem 1.06rem 0.5rem;
}
.pay_active .pay_box {
  bottom: 0;
  transition: all 2s ease-in;
}

.pay_close {
  padding: 0.36rem 0.24rem 0 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: flex-end;
}
.pay_close_img {
  width: 0.72rem;
  height: 0.72rem;
}
.pay_title {
  text-align: center;
  font-size: 0.6rem;
  color: var(--payTitle);
}
.pay_card_box {
  margin-top: 0.56rem;
  border-top: 0.03rem dashed rgba(0, 0, 0, 0.3);
  padding: 0.29rem 0 0;
}
.pay_card {
  height: 1.44rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pay_card_left {
  display: flex;
  align-items: center;
}
.pay_card_left_text {
  margin-left: 0.54rem;
  color: var(--payCardText);
  font-size: 0.48rem;
}
.pay_card_left_url {
  display: flex;
  align-items: center;
}
.pay_card_left_img {
  width: 1.2rem;
  height: 0.72rem;
  object-fit: contain;
}
.pay_card_right {
  width: 1rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.pay_card_right_img {
  width: 0.54rem;
  height: 0.54rem;
}
.pay_card_right_input {
  /* opacity: 0; */
  display: inline-block;
  position: absolute;
  opacity: 0;
  width: 25px;
  height: 25px;
  cursor: pointer;
  left: 0px;
  outline: none;
  -webkit-appearance: none;
}
.pay_button {
  box-sizing: border-box;
  margin: 1.18rem auto 0;
  width: 8.64rem;
  height: 1.2rem;
  line-height: 1.2rem;
  background-color: var(--payBtn);
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.6rem;
  color: var(--payBtnColor);
}
.pay_button_active {
  background-color: var(--payBtnActive);
}
.pay_button2 {
  margin: 1.18rem auto 0;
  width: 8.64rem;
  height: 1.2rem;
  background-color: #e9edee;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.6rem;
  color: #a4a8a9;
  font-size: 0.48rem;
}

/* 加载中提示框 */
.tooltip {
  position: fixed;
  z-index: 11000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tooltip_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.tooltip_box {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.9);
  padding: 0.4rem 0.5rem;
  border-radius: 0.48rem;
}
.tooltip_url {
  width: 0.5rem;
  height: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tooltip_img {
  width: 0.5rem;
  height: 0.5rem;
}
.tooltip_text {
  margin-top: 0.2rem;
  color: #ffffff;
  font-size: 0.48rem;
}

.payMoney {
  color: var(--payMoney);
  font-size: 0.6rem;
}
.payText {
  color: var(--payText);
  font-size: 0.36rem;
  opacity: 0.54;
}
</style>



// WEBPACK FOOTER //
// src/components/pay.vue